module.exports = __webpack_public_path__ + "img/verified.44774472.svg";